import React from 'react';
import { SkeletonBodyText, SkeletonPage, SkeletonDisplayText, Layout, Card, TextContainer, Stack } from '@shopify/polaris';

export default (props) => {
  const { secondary = false, metrics = false } = { ...props };
  return (
    <SkeletonPage primaryAction breadcrumbs={true}>
      <Layout>
        <Layout.Section>
          <Card sectioned>
            <SkeletonBodyText />
          </Card>
          <Card sectioned>
            <TextContainer>
              <SkeletonDisplayText size='small' />
              <SkeletonBodyText />
            </TextContainer>
          </Card>
          {metrics && (
            <>
              <br />
              <div className={'analytics__resume'}>
                <Card sectioned>
                  <SkeletonBodyText lines={5} />
                </Card>
                <Card sectioned>
                  <SkeletonBodyText lines={5} />
                </Card>
                <Card sectioned>
                  <SkeletonBodyText lines={5} />
                </Card>
                <Card sectioned>
                  <SkeletonBodyText lines={5} />
                </Card>
              </div>
              <br />
            </>
          )}
          <Card sectioned>
            <TextContainer>
              <SkeletonDisplayText size='small' />
              <SkeletonBodyText />
            </TextContainer>
          </Card>
          <Card sectioned>
            <TextContainer>
              <SkeletonDisplayText size='small' />
              <SkeletonBodyText />
            </TextContainer>
          </Card>
          <Card sectioned>
            <TextContainer>
              <SkeletonDisplayText size='small' />
              <SkeletonBodyText />
            </TextContainer>
          </Card>
        </Layout.Section>
        {secondary && (
          <Layout.Section secondary>
            <Card>
              <Card.Section>
                <TextContainer>
                  <SkeletonDisplayText size='small' />
                  <SkeletonBodyText lines={2} />
                </TextContainer>
              </Card.Section>
              <Card.Section>
                <SkeletonBodyText lines={1} />
              </Card.Section>
            </Card>
            <Card subdued>
              <Card.Section>
                <TextContainer>
                  <SkeletonDisplayText size='small' />
                  <SkeletonBodyText lines={2} />
                </TextContainer>
              </Card.Section>
              <Card.Section>
                <SkeletonBodyText lines={3} />
              </Card.Section>
            </Card>
            <Card>
              <Card.Section>
                <SkeletonBodyText lines={2} />
              </Card.Section>
            </Card>
          </Layout.Section>
        )}
      </Layout>
    </SkeletonPage>
  );
};
